import { BaseAdapter } from './base.adapter';
import { Named, Owned } from '../base/named';
import { A365Named } from '../base/a365Named';
import { Folder } from '../folder/folder';

export class NamedAdapter<T extends Named, U, D = unknown> extends BaseAdapter<T, U, D> {

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    protected _toResource(named: Named): any {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const aresource = ({} as any);
        aresource.name = this.context.identityProvider.identity(named);
        if (this.context.adapterConfig.referenceById) {
            aresource.objectId = named.objectId;
        }
        if (named.description) {
            this.properties(aresource).description = named.description;
        }
        if (named instanceof A365Named && named.folder && named.useShellFolder) {
            this.properties(aresource).folder = this.context.adapterFor(Folder.MODEL).toResource(named.folder);
        }
        return aresource;

    }

    protected _toModel(resource: {}, named?: Named): T {
        if (!named) {
            throw new Error(' Cannot create abstract named');
        }

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const aresource = (resource as any);
        named.name = this.context.identityProvider.name(aresource);
        if (this.context.adapterConfig.referenceById) {
            named.objectId = aresource?.objectId;
        }
        named.workspaceObjectId = aresource?.workspaceObjectId;
        if (aresource.properties) {
            named.description = aresource.properties.description || undefined;

            if (aresource.properties.folder && named instanceof A365Named && named.useShellFolder) {
                named.folder = Owned.create<Folder>(Folder.MODEL, named);
                this.context.adapterFor(Folder.MODEL).toModel(aresource.properties.folder, named.folder);
            }

            if (aresource.properties.extraTridentInfo) {
                named.extraTridentInfo = JSON.parse(aresource.properties.extraTridentInfo);
            }
        }

        return aresource;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    protected properties(resource: {}): any {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const aresource = (resource as any);
        if (!aresource.properties) {
            aresource.properties = {};
        }

        return aresource.properties;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    protected typeProperties(resource: {}): any {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const properties = this.properties(resource);
        if (!properties.typeProperties) {
            properties.typeProperties = {};
        }
        return properties.typeProperties;
    }
}
